<template>
  <div style="height: 100%; background: #f5f5f5">
    <v-app-bar app elevation="0" class="mb-3" color="white">
      <div class="d-flex flex-row align-center" @click="clockAction">
        <v-img
          alt="On the clock now"
          class="shrink mr-2"
          @click="$router.go(0)"
          contain
          src="../../assets/fullLogo.png"
          transition="scale-transition"
          width="160"
        />
      </div>
      <v-spacer></v-spacer>
      {{ version }}-d
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click.stop.prevent="switchLocation">
            <v-list-item-title>Switch Location</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop.prevent="downloadSupport">
            <v-list-item-title>Support Software</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <!-- <div>returnMessage: {{ returnMessage }}</div> -->
    <div class="text-center mt-2">
      <!-- isAndroidApp: {{ isAndroidApp }} | {{ showPinVerify }} |
      {{ showEnrollment }}
      <div v-if="isAndroidApp">✅ Running inside Android App</div>
      <div v-else>🌐 Running in Browser</div> -->
      <div>
        Fingerprint Device connected:
        <strong>{{ isDeviceConnected ? "✅ Yes" : "❌ No" }}</strong>
      </div>
    </div>
    <v-row justify="center">
      <v-col
        class="shrink pb-0 pt-0"
        v-if="metadata && metadata.customClockIn.storeTimeClockImage"
      >
        <WebCam
          class="ml-1"
          v-if="metadata && metadata.customClockIn.storeTimeClockImage"
          style="display: none"
          ref="webcam"
          width="120"
          height="120"
        ></WebCam>
        <WebCam
          class="ml-1"
          v-if="metadata && metadata.customClockIn.storeTimeClockImageView"
          ref="webcam"
          width="120"
          height="120"
        ></WebCam>
      </v-col>
      <v-col class="pb-0">
        <!-- <h3 class="text-center">{{ timeClockStatus }}</h3> -->
        <div class="text-center text-h6 mt-5">
          {{ location.name }}
        </div>
        <div id="clock" class="text-center">
          <div class="time display-1">{{ todayDate | moment("LT") }}</div>
          <div class="date">{{ todayDate | moment("dddd, D YYYY") }}</div>
        </div>
      </v-col>
    </v-row>

    <div v-if="!selectedEmployee">
      <v-snackbar
        :timeout="-1"
        color="grey lighten-2"
        style="margin-top: 120px"
        rounded="pill"
        elevation="24"
        top
        centered
        v-model="snackbar"
      >
        <div style="color: black">Search: {{ search }}</div>
        <template v-slot:action="{ attrs }">
          <v-btn icon color="pink" text v-bind="attrs" @click="backString">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn icon color="pink" text v-bind="attrs" @click="clearBtn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </div>

    <div v-if="!selectedEmployee && $vuetify.breakpoint.smAndDown">
      <v-btn-toggle class="ma-2 pt-2 px-5 noscroll" style="background: #f3f3f3">
        <v-btn @click="alfClcik(al)" v-for="(al, index) in alf" :key="index">
          {{ al }}
        </v-btn>
      </v-btn-toggle>
    </div>

    <v-container class="mt-2 py-0" grid-list-lg>
      <v-row>
        <v-col cols="2" v-if="!$vuetify.breakpoint.smAndDown">
          <div
            :class="{
              'touch-view-container': $vuetify.breakpoint.smAndDown,
              'touch-view-container-big': !$vuetify.breakpoint.smAndDown,
            }"
          >
            <v-list>
              <v-list-item
                :class="[
                  index % 2 === 0 ? 'even-background' : 'odd-background',
                ]"
                @click="alfClcik(al)"
                v-for="(al, index) in alf"
                :key="index"
              >
                <v-list-item-content>
                  <v-list-item-title class="text-center">{{
                    al
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-col>
        <v-col>
          <v-card
            outlined
            width="100%"
            :class="{
              'touch-view-container': $vuetify.breakpoint.xsOnly,
              'touch-view-container-big': !$vuetify.breakpoint.xsOnly,
            }"
            class="rounded-lg"
          >
            <v-card-text>
              <v-list two-line>
                <!-- <v-card color="primary" class="mt-2">
                  <v-chip class="my-2 font-weight-bold" label color="primary" text-color="white">{{
                    department.departmentName }}</v-chip>
                </v-card> -->
                <div v-if="showDepartment && showDepartmentSetting">
                  <div
                    v-for="(department, index) in filteredItems"
                    :key="department.departmentName"
                  >
                    <v-card color="primary" style="margin-top: 20px !important">
                      <v-layout row wrap align-center>
                        <v-flex xs6>
                          <v-chip
                            class="my-2 font-weight-bold"
                            label
                            color="primary"
                            text-color="white"
                            >{{ department.departmentName }}</v-chip
                          >
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs6 shrink class="text-right">
                          <v-chip
                            class="my-2 font-weight-bold text-right"
                            label
                            color="primary"
                            text-color="white"
                            >{{ department.employees.length }}</v-chip
                          >
                        </v-flex>
                      </v-layout>
                    </v-card>
                    <template v-for="(employee, index) in department.employees">
                      <v-list-item
                        :class="[
                          index % 2 === 0
                            ? 'even-background'
                            : 'odd-background',
                        ]"
                        @click.stop.prevent="setSelectedEmployee(employee)"
                      >
                        <v-list-item-avatar
                          color="grey lighten-3"
                          v-if="
                            employee &&
                            employee.metadata &&
                            employee.metadata.fingerprintEnrolled
                          "
                        >
                          <v-icon color="green darken-4">
                            mdi-fingerprint
                          </v-icon>
                        </v-list-item-avatar>
                        <v-list-item-avatar color="red lighten-5" v-else>
                          <v-icon color="red darken-4">
                            mdi-fingerprint-off
                          </v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="text-h6 text-capitalize">
                            {{ employee.name }}
                          </v-list-item-title>
                          <v-list-item-subtitle
                            v-if="employee.TimeClocks.length !== 0"
                          >
                            <div
                              v-if="
                                employee.TimeClocks[0].status === 'clockedIn' ||
                                employee.TimeClocks[0].status === 'breakStart'
                              "
                            >
                              {{
                                employee.TimeClocks[0].clockInTime
                                  | moment("ddd")
                              }}
                              -
                              {{
                                employee.TimeClocks[0].clockInTime
                                  | moment("M/D/YY h:mm A")
                              }}
                            </div>
                            <div v-else>
                              {{
                                employee.TimeClocks[0].clockOutTime
                                  | moment("ddd")
                              }}
                              -
                              {{
                                employee.TimeClocks[0].clockOutTime
                                  | moment("M/D/YY h:mm A")
                              }}
                            </div>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action-text
                          v-if="employee.TimeClocks.length === 0"
                        >
                          Never
                        </v-list-item-action-text>
                        <v-list-item-action-text v-else class="text-right">
                          <!-- when employee is clocked in  -->
                          <div
                            class="font-weight-bold green--text text-right"
                            v-if="employee.TimeClocks[0].status === 'clockedIn'"
                          >
                            <v-chip color="green" text-color="white">
                              IN
                              <v-avatar right class="green darken-4">
                                <v-icon small
                                  >mdi-location-enter</v-icon
                                ></v-avatar
                              >
                            </v-chip>
                          </div>

                          <!-- when employee on break -->
                          <div
                            class="font-weight-bold green--text text-right"
                            v-else-if="
                              employee.TimeClocks[0].status === 'breakStart'
                            "
                          >
                            <v-chip color="yellow darken-3" text-color="white">
                              On Break
                              <v-avatar right class="yellow darken-4">
                                <v-icon small>mdi-coffee-to-go-outline</v-icon>
                              </v-avatar>
                            </v-chip>
                          </div>

                          <!-- when employee is clocked out  -->
                          <div class="font-weight-bold red--text" v-else>
                            <v-chip color="red" text-color="white">
                              OUT
                              <v-avatar right class="red darken-4">
                                <v-icon small
                                  >mdi-location-exit</v-icon
                                ></v-avatar
                              >
                            </v-chip>
                          </div>

                          <!-- show clock out time only when its clocked in or on break -->
                          <div
                            v-if="
                              employee.TimeClocks[0].status === 'clockedIn' ||
                              employee.TimeClocks[0].status === 'breakstart'
                            "
                            class="caption"
                          >
                            {{
                              employee.TimeClocks[0].clockInTime
                                | moment("from", "now")
                            }}
                          </div>
                        </v-list-item-action-text>
                      </v-list-item>
                      <v-divider
                        v-if="index + 1 < employees.length"
                        :key="index"
                      ></v-divider>
                    </template>
                  </div>
                </div>

                <div v-else>
                  <template v-for="(employee, index) in filteredItems">
                    <v-list-item
                      :class="[
                        index % 2 === 0 ? 'even-background' : 'odd-background',
                      ]"
                      @click.stop.prevent="setSelectedEmployee(employee)"
                    >
                      <v-list-item-avatar
                        color="grey lighten-3"
                        v-if="
                          employee &&
                          employee.metadata &&
                          employee.metadata.fingerprintEnrolled
                        "
                      >
                        <v-icon> mdi-fingerprint </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-avatar color="grey lighten-3" v-else>
                        <v-icon> mdi-fingerprint-off </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="text-h6 text-capitalize">
                          {{ employee.name }}
                        </v-list-item-title>
                        <v-list-item-subtitle
                          v-if="employee.TimeClocks.length !== 0"
                        >
                          <div
                            v-if="
                              employee.TimeClocks[0].status === 'clockedIn' ||
                              employee.TimeClocks[0].status === 'breakStart'
                            "
                          >
                            {{
                              employee.TimeClocks[0].clockInTime | moment("ddd")
                            }}
                            -
                            {{
                              employee.TimeClocks[0].clockInTime
                                | moment("M/D/YY h:mm A")
                            }}
                          </div>
                          <div v-else>
                            {{
                              employee.TimeClocks[0].clockOutTime
                                | moment("ddd")
                            }}
                            -
                            {{
                              employee.TimeClocks[0].clockOutTime
                                | moment("M/D/YY h:mm A")
                            }}
                          </div>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action-text
                        v-if="employee.TimeClocks.length === 0"
                      >
                        Never
                      </v-list-item-action-text>
                      <v-list-item-action-text v-else class="text-right">
                        <!-- when employee is clocked in  -->
                        <div
                          class="font-weight-bold green--text text-right"
                          v-if="employee.TimeClocks[0].status === 'clockedIn'"
                        >
                          <v-chip color="green" text-color="white">
                            IN
                            <v-avatar right class="green darken-4">
                              <v-icon small
                                >mdi-location-enter</v-icon
                              ></v-avatar
                            >
                          </v-chip>
                        </div>

                        <!-- when employee on break -->
                        <div
                          class="font-weight-bold green--text text-right"
                          v-else-if="
                            employee.TimeClocks[0].status === 'breakStart'
                          "
                        >
                          <v-chip color="yellow darken-3" text-color="white">
                            On Break
                            <v-avatar right class="yellow darken-4">
                              <v-icon small>mdi-coffee-to-go-outline</v-icon>
                            </v-avatar>
                          </v-chip>
                        </div>

                        <!-- when employee is clocked out  -->
                        <div class="font-weight-bold red--text" v-else>
                          <v-chip color="red" text-color="white">
                            OUT
                            <v-avatar right class="red darken-4">
                              <v-icon small>mdi-location-exit</v-icon></v-avatar
                            >
                          </v-chip>
                        </div>

                        <!-- show clock out time only when its clocked in or on break -->
                        <div
                          v-if="
                            employee.TimeClocks[0].status === 'clockedIn' ||
                            employee.TimeClocks[0].status === 'breakstart'
                          "
                          class="caption"
                        >
                          {{
                            employee.TimeClocks[0].clockInTime
                              | moment("from", "now")
                          }}
                        </div>
                      </v-list-item-action-text>
                    </v-list-item>
                    <v-divider
                      v-if="index + 1 < filteredItems.length"
                      :key="index"
                    ></v-divider>
                  </template>
                </div>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <CSPLoader v-if="loading" />

    <ChangePin
      :changeEmployee="selectedEmployee"
      :dialog="changePinDialog"
      @close="changePinDialog = !changePinDialog"
    />

    <PinVerificationDialog
      v-model="showPinVerify"
      :employee="selectedEmployee"
      @verifyPin="handlePinVerification"
    />

    <FingerprintEnrollmentDialog
      v-model="showEnrollment"
      :employee="selectedEmployee"
      @enrolled="handleEnrollmentComplete"
    />

    <v-dialog v-model="statusCheckDialog" persistent width="350">
      <v-card elevation="15" class="rounded-lg">
        <v-card-title primary-title>
          <v-layout row>
            <v-flex> Select One </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink>
              <v-btn icon @click="statusCheckDialog = !statusCheckDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-container grid-list-lg>
          <v-layout row>
            <v-flex xs6>
              <v-card
                height="150"
                width="150"
                dark
                color="green"
                @click="setClockInOrOut('clockedIn')"
              >
                <v-layout align-center row fill-height>
                  <v-flex>
                    <div class="text-center">
                      <v-icon x-large>mdi-clock-in</v-icon>
                      <div class="text-h5">Clock In</div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs6>
              <v-card
                height="150"
                width="150"
                dark
                color="red"
                @click="setClockInOrOut('clockedOut')"
              >
                <v-layout align-center row fill-height>
                  <v-flex>
                    <div class="text-center">
                      <v-icon x-large>mdi-clock-out</v-icon>
                      <div class="text-h5">Clock Out</div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>

    <PinEntry
      :metadata="metadata"
      :integration="integration"
      :locationCode="locationCode"
      @closeSubmit="closeSubmit"
      :pinDialog="pinDialog"
      @close="pinClose"
      :selectedEmployee="selectedEmployee"
    />

    <v-dialog v-model="loadingClockIn" persistent width="300">
      <v-card color="primary" class="rounded-lg" dark>
        <v-card-text class="py-6">
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- <Submit v-if="submitDialog" :setting="integration" :employeeImage="image" :status="status" :action="action"
      :dialog="submitDialog" @close="closeSubmit" :employee="selectedEmployee" /> -->

    <TimeClockAction
      v-if="TimeClockActionDialog"
      @cancel="closeTimeClockAction"
      @submit="submitTimeClockAction"
      :employee="actionEmployee"
      :modal="TimeClockActionDialog"
    />

    <ClockStatusOverlay
      :visible="showStatusOverlay"
      :employeeName="overlayEmployeeName"
      :status="overlayStatus"
    />
  </div>
</template>

<script>
import authService from "@/modules/Authentication/service.js";
import TimeClockAction from "@/modules/TimeClock/components/TimeClockActionDialog.vue";
import publicService from "@/api/public";
import FingerprintEnrollmentDialog from "@/modules/TimeClock/components/FingerprintEnrollmentDialog.vue";
import PinVerificationDialog from "@/modules/TimeClock/components/PinVerificationDialog.vue";
import employeeService from "@/modules/Employee/service";
import timeClockService from "@/modules/TimeClock/service.js";
// import Appbar from "@/components/Appbar.vue";
import { mapGetters, mapActions } from "vuex";
const pjson = require("../../../package.json");
import ChangePin from "@/modules/Employee/components/ChangePin.vue";
import PinEntry from "@/modules/TimeClock/components/PinEntry.vue";
const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");
import { WebCam } from "vue-cam-vision";
import ClockStatusOverlay from "@/components/ClockStatusOverlay.vue";
// import settingService from "@/modules/Settings/service.js";
// import Submit from "@/modules/TimeClock/components/submit.vue";
// import NoSleep from "nosleep.js";

export default {
  name: "clockInOut",
  data() {
    return {
      showStatusOverlay: false,
      overlayEmployeeName: "",
      overlayStatus: "", // 'in' or 'out'
      isEnrolling: false,
      returnMessage: null,
      showPinVerify: false,
      showEnrollment: false,
      isDeviceConnected: false,
      isAndroidApp: false,
      showDepartment: false,
      showDepartmentSetting: false,
      clockInOrOut: null,
      statusCheckDialog: false,
      pinDialog: false,
      TimeClockActionDialog: false,
      action: null,
      actionEmployee: null,
      snackbar: false,
      groupedEmployees: [],
      integration: null,
      loadingClockIn: false,
      search: "",
      alf: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      submitDialog: false,
      changePinDialog: false,
      interval: null,
      todayDate: null,
      pointerMode: "PointerEvent" in window,
      loading: false,
      pinError: false,
      pinCodeCircles: [1, 2, 3, 4],
      timeClock: {
        EmployeeId: null,
        pinCode: null,
      },
      noSleep: null,
      status: null,
      pin: "",
      location: null,
      locationCode: null,
      deviceCode: null,
      deviceName: null,
      employees: [],
      selectedEmployee: null,
      numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      metadata: {
        customClockIn: {
          storeTimeClockImage: false,
          storeTimeClockImageView: false,
        },
      },
      image: null,
    };
  },
  beforeDestroy() {
    console.log("beforeDestroy called");
    // prevent memory leak
    clearInterval(this.interval);
    // this.noSleep.disable();
  },
  components: {
    // Submit,
    ChangePin,
    WebCam,
    PinVerificationDialog,
    TimeClockAction,
    FingerprintEnrollmentDialog,
    ClockStatusOverlay,
    PinEntry,
  },
  async created() {
    if (typeof window.AndroidApp !== "undefined") {
      this.isAndroidApp = true;
      this.message = "✅ Running inside Android WebView";
    } else {
      this.isAndroidApp = false;
      this.message = "🌐 Running in normal browser";
    }
    window.onDeviceStatusChanged = (status) => {
      this.isDeviceConnected = status;
      // console.log("Device status:", status ? "connected" : "disconnected");
      this.message = status
        ? "✅ Fingerprint device ready to capture"
        : "⚠️ Fingerprint device disconnected";
    };

    this.todayDate = this.$moment();

    this.interval = setInterval(() => {
      this.todayDate = this.$moment();
      if (this.todayDate.format("hhmm") === "1100") {
        this.$router.go();
      }
    }, 60000);

    if (!localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}code`)) {
      this.$router.push({ name: "authentication-find-location" });
    }

    if (this.$route.params & this.$route.params.locationCode) {
      this.locationCode = this.$route.params.locationCode;
      this.deviceName = this.$route.params.deviceName;
    } else if (
      localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}code`)
    ) {
      this.locationCode = localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}code`
      );
    }

    this.joinSocketChannels();
    let location = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}location`
    );
    if (location) {
      this.location = JSON.parse(location);
    }

    const { deviceName, deviceCode } = authService.getStoredDevice();
    this.deviceName = deviceName;
    this.deviceCode = deviceCode;
    if (
      !localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}deviceCode`)
    ) {
      localStorage.setItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}deviceCode`,
        this.deviceCode
      );
    }

    // this.$nextTick(() => {
    //   this.noSleep = new NoSleep();
    //   this.noSleep.enable();
    // });

    await this.loadSetting();
    await this.getEmployeesList();
  },
  mounted() {
    // ✅ Handle real-time fingerprint match directly from Android
    window.onFingerprintMatch = async (data) => {
      const parsed = typeof data === "string" ? JSON.parse(data) : data;
      if (!parsed) return;

      const { id, score } = parsed;
      const emp = this.employees?.find((e) => e.id === id) || null;

      if (!emp) {
        console.warn("No matching employee found in local list.");
        return;
      }

      this.selectedEmployee = emp;

      console.log("✅ Fingerprint match found:", emp.name, "Score:", score);

      // Show quick toast or confirmation
      this.$toast.success(`Match found: ${emp.name} (${score.toFixed(2)})`, {
        timeout: 2000,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: false,
      });

      // 🔥 Automatically perform clock in/out
      await this.autoClockInOut(emp);
    };

    // ✅ Fallback: handle base64 if Android didn’t match locally
    window.onFingerprintScan = async (base64) => {
      if (this.isEnrolling) return;

      this.$toast.success(`Fingerprint received (${base64.slice(0, 10)}...)`, {
        timeout: 2000,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: false,
      });

      clearTimeout(this.fingerprintTimer);
      // console.log("is running", this.isAndroidApp);
      // this.fingerprintTimer = setTimeout(() => {
      //   this.handleFingerprintScan(base64);
      // }, 300);
    };
  },
  computed: {
    ...mapGetters("global", ["employeeList", "getTimeClockUsers"]),
    filteredItems() {
      if (this.search) {
        return this.employees.filter((item) => {
          return (
            item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        });
      } else {
        if (
          !this.groupedEmployees.length ||
          this.groupedEmployees.length === 1 ||
          !this.showDepartmentSetting
        ) {
          return this.employees;
        } else {
          return this.groupedEmployees;
        }
      }
    },
    version() {
      // console.log('pjson', pjson.version)
      return pjson.version;
    },
    timeClockStatus() {
      let timeClockStatus = "Clock In/Out";
      if (this.status === "clockedIn") return "Clock Out";
      if (this.status === "clockedOut") return "Clock In";
      if (this.status === "breakStart") return "End Break";
      if (this.status === "breakEnd") return "Start Break";
      return timeClockStatus;
    },
  },
  sockets: {
    connect() {
      // console.log("socket connected LAYOUT");
      // Make sure to rejoin the channels
      this.joinSocketChannels();
    },
    notification() {
      console.log(
        'this method was fired by the socket server. eg: io.emit("notification", data)'
      );
    },
    message(data) {
      console.log("New message.", data);
    },
    employeeStatusChange() {
      console.log("employee status change by socket");
      this.getEmployeesList();
    },
    settingChange() {
      console.log("setting got call");
      // this.loadSetting();
      this.$router.go();
    },
  },
  watch: {
    search(val) {
      if (val.length === 0) {
        this.showDepartment = true;
        this.snackbar = false;
      } else {
        this.showDepartment = false;
      }
      // console.log('search', val, this.showDepartment, this.filteredItems)
    },
    async pin() {
      // Reseting Pin
      if (this.pin.length === 5) {
        this.pin = "";
      }

      // Submiting
      if (this.pin.length === 4) {
        if (this.metadata && this.metadata.customClockIn.storeTimeClockImage) {
          this.loadingClockIn = true;
          this.image = await this.getImage();
          if (this.image) this.image.status = this.status;
        }
        if (this.checkToken()) {
          // console.log("have token", this.checkToken());
          this.clockInOutEmployee();
        } else {
          // console.log("no token");
          this.submitWithClockIn();
        }
      }
    },
  },
  methods: {
    ...mapActions("global", [
      "setEmployeeList",
      "setTimeClockAdmins",
      "setTimeClockEmployees",
    ]),

    async autoClockInOut(employee) {
      try {
        if (!employee || !employee.id) {
          console.warn("No employee provided for autoClockInOut");
          return;
        }

        const { deviceName, deviceCode } = authService.getStoredDevice();
        const pin = employee.pinCode;
        const locationId = employee.LocationEmployee?.LocationId;
        const locationCode = this.locationCode;

        if (!pin) {
          this.$toast.error("No PIN found for this employee.");
          return;
        }

        const timeClock = {
          EmployeeId: employee.id,
          pinCode: pin,
          LocationId: locationId,
        };

        const isClockedIn = employee.TimeClocks?.[0]?.status === "clockedIn";

        // Overlay helper
        const showOverlay = (emp, status) => {
          this.overlayEmployeeName = emp.name;
          this.overlayStatus = status;
          this.showStatusOverlay = true;

          setTimeout(() => {
            this.showStatusOverlay = false;
          }, 3000);
        };

        // ==============================================
        // 1. TEST TOKEN (NEW FIX)
        // ==============================================
        let tokenIsValid = false;

        const token = localStorage.getItem(
          `${process.env.VUE_APP_STORAGE_PREFIX}token`
        );

        if (token) {
          try {
            // Call any small endpoint that requires authentication
            await authService.verify(); // or getProfile(), whatever exists in your service
            tokenIsValid = true;
            console.log("🔑 Token is valid");
          } catch (e) {
            console.warn("⚠️ Token INVALID, removing…");
            tokenIsValid = false;
            localStorage.removeItem(
              `${process.env.VUE_APP_STORAGE_PREFIX}token`
            );
          }
        }

        // ==============================================
        // 2. If token valid → clock in/out
        // ==============================================
        if (tokenIsValid) {
          console.log("➡️ Using existing valid token");

          if (isClockedIn) {
            const result = await timeClockService.clockOut({
              ...timeClock,
              clockOutTime: this.$moment().toISOString(),
              clockOutFingerprint: true,
            });

            if (result) {
              showOverlay(employee, "out");
              this.selectedEmployee.status = "clockedOut";
            }
          } else {
            const result = await timeClockService.clockIn({
              ...timeClock,
              clockInTime: this.$moment().toISOString(),
              clockInNote: "Clocked In via Fingerprint",
              clockInFingerprint: true,
            });

            if (result) {
              showOverlay(employee, "in");
              this.selectedEmployee.status = "clockedIn";
            }
          }

          // ==============================================
          // 3. No valid token → authenticate first
          // ==============================================
        } else {
          console.log("➡️ No valid token, authenticating first…");

          const loginInfo = {
            id: employee.id,
            pin,
            locationCode,
            deviceCode,
            deviceName,
          };

          await authService.authenticate(loginInfo);
          await authService.setLastEmployeeId(employee.id);

          if (isClockedIn) {
            const result = await timeClockService.clockOut({
              EmployeeId: employee.id,
              pinCode: pin,
              clockOutTime: this.$moment().toISOString(),
              clockOutFingerprint: true,
            });

            if (result) {
              showOverlay(employee, "out");
              this.selectedEmployee.status = "clockedOut";
            }
          } else {
            const result = await timeClockService.clockIn({
              EmployeeId: employee.id,
              pinCode: pin,
              clockInTime: this.$moment().toISOString(),
              clockInNote: "Clocked In via Fingerprint",
              clockInFingerprint: true,
            });

            if (result) {
              showOverlay(employee, "in");
              this.selectedEmployee.status = "clockedIn";
            }
          }
        }

        // ==============================================
        // Finish up
        // ==============================================
        this.loadingClockIn = false;
        this.openSubmitDialog = true;
        await this.getEmployeesList();
      } catch (error) {
        console.error("Error in autoClockInOut:", error);
        this.loadingClockIn = false;

        this.$toast.error(error.data?.message || "Auto clock in/out failed.", {
          timeout: 2500,
        });

        localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`);
      }
    },

    async handleFingerprintScan(base64) {
      console.log(
        "Handling fingerprint scan for backend match...",
        this.isAndroidApp
      );
      // If running in Android app, we already get match results from Android
      if (this.isAndroidApp) {
        console.log(
          "🧠 Android handles fingerprint matching locally. Skipping backend check."
        );
        return;
      }

      // Only run this block when in browser mode (no Android)
      try {
        this.$toast.info("Browser mode: verifying fingerprint via backend...");

        const payload = {
          template: base64,
          OrganizationId: this.location?.OrganizationId,
        };

        const res = await publicService.matchFingerprint(payload);
        const result = res.data || res;

        if (result.success && result.employee) {
          this.$swal.fire({
            title: "✅ Match Found (Server)",
            html: `
          <div style="text-align:left; line-height:1.6;">
            <strong>Name:</strong> ${result.employee.name || "Unknown"}<br/>
            <strong>ID:</strong> ${result.employee.id}<br/>
            <strong>Pin:</strong> ${result.employee.pinCode}<br/>
            <strong>Score:</strong> ${
              result.score ? result.score.toFixed(2) : "N/A"
            }
          </div>
        `,
            icon: "success",
          });

          this.selectedEmployee = result.employee;
        } else {
          this.$swal.fire({
            title: "No Match Found",
            text: "This fingerprint does not match any enrolled employee.",
            icon: "error",
          });
        }
      } catch (err) {
        console.error("❌ Error matching fingerprint:", err);
        this.$toast.error("Error while matching fingerprint");
      }
    },
    openPinVerificationDialog() {
      this.showPinVerify = true;
    },
    async handleEnrollmentComplete(templates) {
      try {
        this.isEnrolling = false;

        let fingerprintTemplate = "";

        // Handle both old (array) and new (single string) formats
        if (Array.isArray(templates)) {
          fingerprintTemplate = templates[0]?.trim() || "";
        } else if (typeof templates === "string") {
          fingerprintTemplate = templates.trim();
        } else {
          console.warn("Unexpected fingerprint enrollment data:", templates);
          this.$toast.error("Invalid fingerprint enrollment data format.");
          return;
        }

        if (!fingerprintTemplate) {
          this.$toast.error("Empty fingerprint template received.");
          return;
        }

        const metadata = {
          ...this.selectedEmployee.metadata,
          fingerprintEnrolled: true,
          fingerprintTries: 0,
          fingerprintTemplate, // 🧠 single string now
        };

        await publicService.updateEmployee(this.selectedEmployee.id, {
          metadata,
          organization: { id: this.location.OrganizationId },
        });

        this.$toast.success("✅ Fingerprint enrollment saved!");
        this.showEnrollment = false;

        // Reload to confirm update
        await this.getEmployeesList();
      } catch (err) {
        console.error("❌ Error saving enrollment:", err);
        this.$toast.error("Failed to save fingerprint enrollment.");
      }
    },
    async handlePinVerification(pin) {
      try {
        const valid = await publicService.verifyPin({
          EmployeeId: this.selectedEmployee.id,
          pinCode: pin,
          OrganizationId: this.location.OrganizationId,
        });

        console.log("valid", valid);
        this.returnMessage = valid.data.valid;

        if (valid?.data?.valid) {
          // ✅ PIN is correct
          this.showPinVerify = false;
          this.showEnrollment = true;
          this.isEnrolling = true;

          if (window.AndroidApp?.startFingerprintEnrollment) {
            window.AndroidApp.startFingerprintEnrollment();
          } else {
            this.$swal.fire({
              title: "Device Error",
              text: "Android interface not available.",
              icon: "error",
              confirmButtonColor: "#d33",
              confirmButtonText: "OK",
              position: "center",
            });
          }

          return true;
        } else {
          // ❌ Invalid PIN entered
          await this.$swal.fire({
            title: "Invalid PIN",
            text: "The PIN you entered is incorrect. Please try again.",
            icon: "error",
            confirmButtonColor: "#d33",
            confirmButtonText: "Retry",
            position: "center",
          });
          return false;
        }
      } catch (err) {
        console.error("PIN verification error:", err);

        const message =
          err?.response?.data?.message ||
          "PIN verification failed. Please try again.";

        await this.$swal.fire({
          title: "PIN Verification Failed",
          text: message,
          icon: "error",
          confirmButtonColor: "#d33",
          confirmButtonText: "OK",
          position: "center",
        });

        return false;
      }
    },
    downloadSupport() {
      window.open(
        "https://play.google.com/store/apps/details?id=com.splashtop.sos&hl=en_US&gl=US"
      );
    },
    joinSocketChannels() {
      const locationCode = localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}code`
      );
      const deviceCode = localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}deviceCode`
      );
      const deviceName = localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}deviceName`
      );
      // console.log("location", locationCode, deviceCode, deviceName);

      if (locationCode && deviceCode) {
        this.$socket.emit("join-location", {
          locationCode,
          deviceCode,
          deviceName,
        });
      }

      //   if (this.$store.getters['global/location']) {
      //     this.$socket.emit('join-organization', {
      //       OrganizationId: this.$store.getters['global/location'].OrganizationId,
      //     });
      //   }
    },
    switchLocation() {
      return this.$swal
        .fire({
          title: "Switch Location",
          input: "password",
          html: "Make sure you have your location code in order to get back in, to reset location type <b>switch</b> in as a password, ",
          inputPlaceholder: "Enter your password",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Submit",
          cancelButtonText: "Cancel",
          inputAttributes: {
            maxlength: 10,
            autocapitalize: "off",
            autocorrect: "off",
          },
        })
        .then((result) => {
          // console.log("resuld", result);
          if (result.isConfirmed) {
            if (result.value === "switch") {
              this.$router.push({ name: "authentication-find-location" });
            } else {
              this.$toast.warning(
                "Wrong Entry, Enter 'switch' to change the location",
                {
                  timeout: 3500,
                }
              );
            }
          }
        })
        .catch((error) => {
          this.$toast.error(error.data ? error.data.message : "Error", {
            timeout: 2000,
          });
        });
    },
    clockAction() {
      this.$router.go(0);
    },
    // getAllSetting() {
    //   return integrationService.getAll().then((response) => {
    //     console.log("setting response getall", response);
    //     this.general = response.data;
    //   });
    // },
    backString() {
      // console.log('backString', this.search)
      // this.search.slice(0,-1)
      this.search = this.search.substring(0, this.search.length - 1);
    },
    clearBtn() {
      this.snackbar = false;
      this.search = "";
    },
    alfClcik(lat) {
      this.snackbar = true;
      // console.log("lat press", this.search, lat);
      this.search += lat;
    },
    checkToken() {
      // const token = localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`)
      // console.log('tokendkaj;lkdjfa;lsdf', token)
      if (localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`))
        return true;
    },
    loadSetting() {
      authService.getLocation(this.locationCode).then((response) => {
        // console.log("authService.getLocation", response);
        response.data.Integrations.map((row) => {
          if (row.pubSubHook === "TERMINALTIMECLOCK") {
            this.integration = row;
            // console.log(row);
          }
        });
        // console.log("integration", this.integration);
        // console.log("response.data.metadat", response.data);
        if (response.data.metadata && response.data.metadata.customClockIn) {
          this.metadata = {
            ...this.metadata,
            ...response.data.metadata,
          };
        } else {
          // this.metadata = {
          //   ...this.metadata,
          // };
          if (
            this.integration &&
            this.integration.LocationIntegration &&
            this.integration.LocationIntegration.metadata
          ) {
            this.metadata = {
              ...this.metadata,
              ...this.integration.LocationIntegration.metadata,
            };
          }
        }
        if (
          this.metadata &&
          this.metadata.customClockIn &&
          this.metadata.customClockIn.showDepartment
        ) {
          this.showDepartmentSetting = true;
        } else {
          this.showDepartmentSetting = false;
        }

        this.checkStatus();
      });
    },
    closeSubmit() {
      // this.loadingClockIn = false;
      // this.submitDialog = false;
      this.pinDialog = false;
      this.selectedEmployee = null;
      // this.pin = "";
      this.getEmployeesList();
    },
    changePin() {
      // console.log("changePin pressed", this.changePinDialog);
      this.changePinDialog = !this.changePinDialog;
    },
    backToList() {
      this.selectedEmployee = null;
      this.action = null;
      this.pin = "";
      this.status = "";
    },
    // async setSelectedEmployee(employee) {
    //   this.selectedEmployee = employee;
    //   this.clearBtn();

    //   // 🧠 Only apply fingerprint logic if running in Android app AND device connected
    //   if (this.isAndroidApp && this.isDeviceConnected) {
    //     const metadata = employee.metadata || {};
    //     const tries = metadata.fingerprintTries || 0;

    //     // 🟡 Not enrolled yet
    //     if (!metadata.fingerprintEnrolled) {
    //       if (tries < 3) {
    //         const result = await this.$swal.fire({
    //           title: "Fingerprint Enrollment",
    //           text: `You need to enroll your fingerprints. You have ${
    //             3 - tries
    //           } attempts left. Enroll now?`,
    //           icon: "question",
    //           showCancelButton: true,
    //           confirmButtonText: "Enroll",
    //           cancelButtonText: "Later",
    //         });

    //         if (result.isConfirmed) {
    //           // 🟢 Start enrollment flow (PIN → fingerprint)
    //           this.openPinVerificationDialog();
    //         } else {
    //           // 🟠 User clicked "Later"
    //           // Increment attempt count but continue normal flow
    //           metadata.fingerprintTries = tries + 1;
    //           try {
    //             await employeeService.update(employee.id, { metadata });
    //           } catch (err) {
    //             console.warn("Failed to update fingerprint tries:", err);
    //           }

    //           this.$toast.info(
    //             `Attempt ${metadata.fingerprintTries}/3 recorded.`
    //           );
    //           this.statusCheckDialog = true; // continue as normal
    //         }
    //       } else {
    //         // 🔴 Forced enrollment after 3 skips
    //         this.$swal
    //           .fire({
    //             title: "Fingerprint Enrollment Required",
    //             text: "You must enroll your fingerprint before continuing.",
    //             icon: "warning",
    //             confirmButtonText: "Start Enrollment",
    //           })
    //           .then(() => this.openPinVerificationDialog());
    //       }
    //       return; // ✅ Stop here so we don’t re-open dialogs twice
    //     }

    //     // ✅ Already enrolled → continue to normal flow
    //     this.statusCheckDialog = true;
    //   } else {
    //     // 🌐 Browser OR no device connected → fallback to normal behavior
    //     this.statusCheckDialog = true;
    //   }
    // },
    setClockInOrOut(selected) {
      // console.log('selected employee', this.selectedEmployee, selected)
      if (selected === this.selectedEmployee.status) {
        if (selected === "clockedIn") {
          this.$swal(
            this.selectedEmployee.name,
            "You are already clocked In",
            "error"
          );
        } else {
          this.$swal(
            this.selectedEmployee.name,
            "You are already clocked Out",
            "error"
          );
        }
      } else {
        this.statusCheckDialog = !this.statusCheckDialog;
        this.openPinDialog();
      }
    },
    async setSelectedEmployee(employee) {
      this.selectedEmployee = employee;
      this.clearBtn();

      // 🧠 If running in Android app with device connected
      if (this.isAndroidApp && this.isDeviceConnected) {
        const metadata = employee.metadata || {};
        const hasFingerprint = !!metadata.fingerprintTemplate; // single-template format

        // ✅ Case 1: Employee already has fingerprint enrolled
        if (hasFingerprint) {
          await this.$swal.fire({
            title: "Scan Your Fingerprint",
            html: `<strong>${employee.name}</strong>, please scan your fingerprint to clock in or out.`,
            icon: "info",
            timer: 5000, // auto-close after 5s
            timerProgressBar: true,
            showConfirmButton: false,
            position: "center",
          });
          // ✅ Nothing else to do — Android will handle match automatically
          return;
        }

        // 🟡 Case 2: Not enrolled yet
        const tries = metadata.fingerprintTries || 0;

        if (!metadata.fingerprintEnrolled) {
          if (tries < 3) {
            const result = await this.$swal.fire({
              title: "Fingerprint Enrollment",
              text: `You need to enroll your fingerprints. You have ${
                3 - tries
              } attempts left. Enroll now?`,
              icon: "question",
              showCancelButton: true,
              confirmButtonText: "Enroll",
              cancelButtonText: "Later",
            });

            if (result.isConfirmed) {
              // 🟢 Start enrollment flow (PIN → fingerprint)
              this.openPinVerificationDialog();
            } else {
              // 🟠 User clicked “Later” — record attempt
              metadata.fingerprintTries = tries + 1;
              try {
                await employeeService.update(employee.id, { metadata });
              } catch (err) {
                console.warn("Failed to update fingerprint tries:", err);
              }
              this.$toast.info(
                `Attempt ${metadata.fingerprintTries}/3 recorded.`
              );
              this.statusCheckDialog = true; // allow manual pin entry
            }
          } else {
            // 🔴 Forced enrollment after 3 skips
            this.$swal
              .fire({
                title: "Fingerprint Enrollment Required",
                text: "You must enroll your fingerprint before continuing.",
                icon: "warning",
                confirmButtonText: "Start Enrollment",
              })
              .then(() => this.openPinVerificationDialog());
          }
          return; // ✅ Stop here
        }
      }

      // 🌐 Fallback for browser or disconnected device
      this.statusCheckDialog = true;
    },
    openPinDialog() {
      //  console.log("e,mployeee is :", employee);

      // this.selectedEmployee = employee;
      this.pinDialog = !this.pinDialog;
      // this.clearBtn();
    },
    pinClose() {
      this.pinDialog = false;
    },
    submitTimeClockAction(action) {
      // console.log('actionactionactionaction', action)
      this.TimeClockActionDialog = false;
      this.action = action;
      // this.status = action
      this.selectedEmployee = this.actionEmployee;
    },
    closeTimeClockAction() {
      this.TimeClockActionDialog = false;
    },
    async getEmployeeStatus() {
      return await employeeService.getEmployeeStatus(this.selectedEmployee.id);
      // if (status.data.TimeClock) {

      // }
      // console.log("result status", status);
    },
    async removeTimeClockToken() {
      if (this.$refs && this.$refs.webcam) {
        this.$refs.webcam.stop();
      }

      localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`);
      this.$router.push({ name: "authentication-employee-login" });
    },
    getEmployeesList() {
      if (this.locationCode) {
        authService
          .getLocation(this.locationCode)
          .then(async (response) => {
            this.location = response.data;
            this.locationCode = response.data.code;
            let employee = response.data.Employees;
            console.log("employee", employee);
            this.employees = [];
            employee.map((row) => {
              if (
                row.metadata &&
                row.metadata.timeClockLogin &&
                row.metadata.timeClockLogin.employee
              ) {
                if (row.TimeClocks.length > 0) {
                  row.status = row.TimeClocks[0].status;
                } else {
                  row.status = "Never";
                }
                this.employees.push(row);
              }
            });

            // 🟢 Send lightweight employee list to Android for local matching (new single-template shape)
            // if (
            //   window.AndroidApp &&
            //   typeof window.AndroidApp.updateEmployeesFromJson === "function"
            // ) {
            //   const simplified = this.employees.map((e) => ({
            //     id: e.id,
            //     name: e.name,
            //     // 👇 send the single merged fingerprint template
            //     fingerprintTemplate: e.metadata?.fingerprintTemplate || "",
            //   }));

            //   const json = JSON.stringify(simplified);
            //   console.log(
            //     "📤 Sending employee list to Android:",
            //     simplified.length,
            //     "employees"
            //   );
            //   window.AndroidApp.updateEmployeesFromJson(json);
            // }

            if (
              window.AndroidApp &&
              typeof window.AndroidApp.loadEmployeeList === "function"
            ) {
              const simplified = this.employees.map((e) => ({
                id: e.id,
                name: e.name,
                fingerprintTemplates: [e.metadata?.fingerprintTemplate || ""], // <-- matches Android interface
              }));

              const json = JSON.stringify(simplified);

              console.log(
                "📤 Sending employee list to Android:",
                simplified.length,
                "employees"
              );

              window.AndroidApp.loadEmployeeList(json);
            }

            // this.employees.sort((a, b) => (a.name > b.name) ? 1 : (a.name === b.name) ? ((a.size > b.size) ? 1 : -1) : -1 )
            if (this.showDepartmentSetting === true) {
              const grouped = this.employees.reduce((acc, employee) => {
                const deptId = employee.DepartmentId
                  ? employee.DepartmentId
                  : "Unassigned";
                if (!acc[deptId]) {
                  acc[deptId] = {
                    departmentName: employee.Department
                      ? employee.Department.name
                      : "Unassigned",
                    employees: [],
                  };
                }
                acc[deptId].employees.push(employee);
                return acc;
              }, {});

              const sortedDepartments = Object.values(grouped).sort((a, b) =>
                a.departmentName.localeCompare(b.departmentName)
              );

              sortedDepartments.forEach((department) => {
                department.employees.sort((a, b) =>
                  a.name.localeCompare(b.name)
                );
              });

              this.groupedEmployees = sortedDepartments;

              if (this.groupedEmployees.length === 1) {
                this.showDepartment = false;
              } else {
                this.showDepartment = true;
              }
            }

            // this.employees.sort((a, b) => (a.name > b.name ? 1 : -1));
            // console.log("this.employees", this.employees);
            // console.log("employees", this.employees);
          })
          .catch((error) => {
            console.log("error on gettong location by location code", error);
          });
      } else {
        return employeeService
          .getAll({
            limit: 50,
            offset: 0,
            local: true,
          })
          .then(async (response) => {
            let employee = response.data;
            this.employees = [];
            employee.map((row) => {
              if (
                row.metadata &&
                row.metadata.timeClockLogin &&
                row.metadata.timeClockLogin.employee
              ) {
                this.employees.push(row);
              }
            });
            this.employees.sort((a, b) => (a.name > b.name ? 1 : -1));
            // console.log("this.employees", this.employees);
          })
          .catch((error) => {
            console.log("error on employee list", error);
            throw error;
          });
      }
    },
    pinCodeStyle(num) {
      if (this.pin.length >= num) return "mdi-circle";
      else return "mdi-checkbox-blank-circle-outline";
    },
    selectedNum(num) {
      num = num.toString();
      this.pin = this.pin.concat(num).trim();
    },
    saveToStorage() {
      authService.setDevice(
        this.locationCode,
        this.deviceName,
        this.deviceCode
      );
    },
    async getTimeClockStatusById(employee) {
      if (employee) {
        try {
          let timeResponse = await timeClockService.getEmployeeTimeClock(
            employee.id
          );
          // console.log("timeResponse", timeResponse);
          if (timeResponse) {
            this.selectedEmployee = timeResponse.data;
            // console.log("timeResponse", timeResponse);
            if (
              timeResponse.data.TimeClocks &&
              timeResponse.data.TimeClocks.length > 0
            ) {
              this.status = timeResponse.data.TimeClocks[0].status;
            } else {
              this.status = "clockedOut";
            }
          } else {
            throw new Error("Employee Not Found");
          }
        } catch (error) {
          throw new Error(error);
        }
      }
    },
    checkStatus() {
      let vm = this;
      navigator.permissions.query({ name: "camera" }).then(function (result) {
        // vm.permission = result.state
        // return result.state

        if (result.state === "denied") {
          vm.metadata.customClockIn.storeTimeClockImage = false;
        }
      });
    },
    async getImage() {
      if (this.$refs && this.$refs.webcam) {
        const base64 = await this.$refs.webcam.capture();
        // console.log("base64base64base64base64", base64);
        if (base64) {
          const obj = {
            dataUrl: base64,
            info: {
              name: `${this.selectedEmployee.name
                .split(" ")
                .join("")}-${new Date().getTime()}.jpg`,
            },
          };
          return obj;
        }
      }
    },
  },
  mixins: [validationMixin],
  validations: {
    selectedEmployee: {
      required,
    },
  },
};
</script>
<style scoped>
.noscroll {
  overflow-y: scroll;
}

div::-webkit-scrollbar {
  display: none;
  /* for Chrome, Safari, and Opera */
}

.touch-view-container {
  height: calc(100vh - 270px);
  width: 100%;
  overflow: auto;
}

.touch-view-container-big {
  height: calc(100vh - 250px);
  width: 100%;
  overflow: auto;
}

.swal2-popup.clockin-popup {
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(46, 125, 50, 0.3);
}

.swal2-popup.clockout-popup {
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(173, 20, 87, 0.3);
}
</style>